import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard/tracer',
    title: 'Dashboard',
    icon: 'fas fa-home',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/dashboard/tracer',
        title: 'Información Accionaria 1',
        icon: 'fas fa-chart-line',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },/*
  {
    path: '',
    title: 'Acto Corporativo',
    icon: 'fas fa-dollar-sign',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/asamblea',
        title: 'Elaboración y firma de Asamblea Anual',
        icon: 'fas fa-fax',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/mismosSocios',
        title: 'Aumento de capital',
        icon: ' fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/asambleaManual',
        title: 'Captura manual de Acta de Asamblea fuerade plataforma',
        icon: ' fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },*/
  ,
  {
    path: '/administracion/actoCorporativo',
    title: 'Actos Corporativos',
    icon: 'fas fa-dollar-sign',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/actoCorporativo',
        title: 'Actos corporativos',
        icon: 'fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Documentos',
    icon: 'fas fa-dolly',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/documentos',
        title: 'Libros Corporativos',
        icon: ' fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/copiaCertificada',
        title: 'Documentos (PLD-KYC)',
        icon: 'fas fa-file-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/mydocuments2',
        title: 'Mis documentos',
        icon: 'fas fa-file-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/signature',
        title: 'Firma Electronica',
        icon: 'fas fa-key',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/hook-archive',
        title: 'Archivo Firma Electronica ',
        icon: 'fa fa-folder',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/powers-of-attorney/',
        title: ' Adm. Poderes Notariales ',
        icon: 'fa fa-folder',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Asistente',
    icon: ' fas fa-hand-holding',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/menu/sociedad',
        title: 'Creación de Sociedad',
        icon: ' fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/videos',
        title: 'Videos Corporativos',
        icon: 'fas fa-video',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Administración',
    icon: 'fas fa-address-book',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/sociedades',
        title: 'Sociedades',
        icon: 'fas fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/editarAccionistas',
        title: 'Accionistas',
        icon: 'fas fa-user',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      }
    ]
  }
];

export const ROUTESMODIFICAR: RouteInfo[] = [
  {
    path: '',
    title: '',
    icon: 'fas fa-home',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/dashboard/tracer',
        title: 'Información Accionaria',
        icon: 'fas fa-chart-line',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '/administracion/actoCorporativo',
    title: 'Actos Corporativos',
    icon: 'fas fa-dollar-sign',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/actoCorporativo',
        title: 'Actos corporativos',
        icon: 'fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Documentos',
    icon: 'fas fa-dolly',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/documentos',
        title: 'Libros Corporativos',
        icon: 'fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/copiaCertificada',
        title: 'Documentos (PLD-KYC)',
        icon: 'fas fa-file-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/mydocuments2',
        title: 'Mis documentos',
        icon: 'fas fa-file-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/signature',
        title: 'Firma Electronica',
        icon: 'fas fa-key',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/hook-archive',
        title: 'Archivo Firma Electronica ',
        icon: 'fa fa-folder',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/powers-of-attorney/',
        title: ' Adm.Poderes Notariales',
        icon: 'fa fa-folder',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Asistente',
    icon: 'fas fa-clipboard-list',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        //path: '/administracion/sociedadNueva',
        path: '/administracion/menu/sociedad',
        title: 'Creación de Sociedad',
        icon: ' fas fa-chart-bar',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/administracion/videos',
        title: 'Videos Corporativos',
        icon: 'fas fa-video',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Administración',
    icon: 'fas fa-address-book',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/sociedades',
        title: 'Sociedades',
        icon: 'fas fa-building',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/editarAccionistas',
        title: 'Accionistas',
        icon: 'fas fa-user',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      }
    ]
  },
  {
    path: '',
    title: 'Configuración',
    icon: 'fas fa-cogs',
    class: 'has-arrow',
    ddclass: '',
    extralink: false,
    submenu: [
      {
        path: '/administracion/configuracion',
        title: 'Email',
        icon: 'fas fa-envelope',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/configuraTipoCopia',
        title: 'Documentos',
        icon: 'fas fa-newspaper',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/configuraTipoAsamblea',
        title: 'Asambleas',
        icon: 'fas fa-newspaper',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/configuracionConsejo',
        title: 'Consejo Administracion',
        icon: 'fas fa-users',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/videosConfiguracion',
        title: 'Manuales',
        icon: 'fas fa-film',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/configuracionNotario',
        title: 'Notarios',
        icon: 'fas fa-pencil-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      },
      {
        path: '/administracion/configuracionPoderes',
        title: 'Catalogo Poderes',
        icon: 'fas fa-pencil-alt',
        class: '',
        ddclass: '',
        extralink: false,
        submenu: [
        ]
      }
    ]
  }

];

